import React, { useState } from "react";
import { Alert, TextField, Button, Checkbox, FormControlLabel, Paper, Typography, Box, Link } from "@mui/material";
import login_logo from "../../assets/login-backgroud.webp"
import rentalCrowLogo from "../../assets/RentalCrow-Logo-Main.png";
import Swal from 'sweetalert2';
import axios from 'axios';
import { Link as RouterLink, useLocation } from 'react-router-dom';

export default function LoginPage({ setLoginSuccess }) {
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });  
  const [formAuth, setFormAuth] = useState({ otp: "" });  
  const [loginDetail, setLoginDetail] = useState("");
  const [showOtpFlag, setShowOtpFlag] = useState(false);
  // const [otpValue, setOtpValue] = useState("");
  const [, setLoginData] = useState(null);
  const [otpExpireTime, setOtpExpireTime] = useState(null);
  const [loadingOTP, setLoadingOTP] = useState(false);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  
  const handleChangeAuth = (e) => {
    setFormAuth({ ...formAuth, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = form.email;
    const password = form.password;
    e.preventDefault();

    if (email.toString().trim() === '') {
      Swal.fire("Please enter Email")
      return;
    }
    if (password.toString().trim() === '') {
      Swal.fire("Please enter Password")
      return;
    }

    axios.post(baseURL + "/check_user_cred", {
      'email': email.toString().trim().toLowerCase(),
      'password': password
    })
      .then((res) => {
        if (res.data.status === 'success') {

            setShowOtpFlag(true);
            axios.post(baseURL + "/mail_authentication_check", {
              'user_email': email.toString().trim().toLowerCase(),
              'role': res.data.data.selected_role
            }).then((res5) => {

              setFormAuth({otp:""});
              setOtpExpireTime((new Date()).valueOf());
              // setGeneratedOTP(res5.data);
              setLoginData(res.data.data);
              setLoginDetail(res.data);

            })
        }
        else if (res.data.status === 'DeActivated') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Your user account has been deactivated, Please contact support@caledontechnologies.com'
          })
          return;
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Email or Password not correct'
          })
          return;
        }

      }).catch((e) => {

        Swal.fire("Email or Password not correct");
        return;
      });
  };

    //Login Authentication
  const handleAuthentication = (e) => {

    e.preventDefault();

    if (formAuth.otp.toString().trim() === '') {
      Swal.fire("Please enter Authentication Key")
      return;
    }

    if ((otpExpireTime + (1000 * 60)) < (new Date()).valueOf()) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Authentication key expired'
      })

      setShowOtpFlag(false);
      return;
    }

    setLoadingOTP(true);

    axios.post(baseURL + "/check_authentication_key", { 'authentication_key': formAuth.otp, 'email': form.email })
      .then((res) => {
      if (res.data === 'Matched') {
        sessionStorage.setItem('user_token_ra', JSON.stringify({
          'userName': loginDetail.data.user_name, 'userEmail': loginDetail.data.user_email, 'account_type': "",
          'role': loginDetail.role, 'account_id': "", 'access': "", 'selected_role':loginDetail.data.selected_role, 'accessRole':loginDetail.data.accessRole,
          'selected_locations': loginDetail.data.selected_locations || loginDetail.data.locations || [],
          'userUniqueId': loginDetail.data.user_unique_id || '',
        }))

        // setLoginSuccess(true);
        window.location.reload();

      }else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Authentication key not matched'
        })

        setShowOtpFlag(false);
      }
      setLoadingOTP(false);
    })
  }

  return (
    <Box
      sx={{
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `
      linear-gradient(rgba(25,118,210,0.65), rgba(101,51,217,0.65)),
      url(${login_logo})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
    >
    {!showOtpFlag ?
      (
        <Paper elevation={10} sx={{ padding: 4, width: 400, borderRadius: 3, backgroundColor: "rgba(255, 255, 255, 0.65)" }}>
          <Box
            component="img"
            src={rentalCrowLogo}
            alt="Rental Crow"
            sx={{ display: 'block', width: '100%', maxWidth: 280, height: 'auto', mx: 'auto', mb: 1.5, borderRadius: 1 }}
          />
          {location.state?.passwordReset ? (
            <Alert severity="success" sx={{ mb: 1.5 }}>Password reset successfully. You can now log in.</Alert>
          ) : null}

          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />

            <TextField
              label="Password"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />

            

            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <FormControlLabel
              control={<Checkbox />}
              label="Remember me"
            />
              <Link component={RouterLink} to="/forgot-password" variant="body2" underline="hover" style={{float:"right",marginTop:11}}>
                Forgot Password?
              </Link>
            </Box>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1, py: 1 }}
            >
              Login
            </Button>
          </form>
        </Paper>
      ):(
        <Paper elevation={10} sx={{ padding: 4, width: 400, borderRadius: 3, backgroundColor: "rgba(255, 255, 255, 0.65)" }}>
          <Box
            component="img"
            src={rentalCrowLogo}
            alt="Rental Crow"
            sx={{ display: 'block', width: '100%', maxWidth: 240, height: 'auto', mx: 'auto', mb: 2, borderRadius: 1 }}
          />
          <Typography variant="h6" align="center" gutterBottom>
            Authentication Key has been sent to your email, Please check
          </Typography>

          <form onSubmit={handleAuthentication}>
            <TextField
              label="OTP"
              name="otp"
              value={formAuth.otp}
              onChange={handleChangeAuth}
              fullWidth
              margin="normal"
              required
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              loading={loadingOTP}
              sx={{ mt: 1, py: 1 }}
            >
              Verify
            </Button>
          </form>
        </Paper>
      )}
    </Box>
  );
}

// Setup Steps:
// 1. npm install @mui/material @emotion/react @emotion/styled
// 2. npm start
